// extracted by mini-css-extract-plugin
module.exports = {"formLabel":"FormInput_formLabel__WXYoc","labelText":"FormInput_labelText__RRPjI","inputEl":"FormInput_inputEl__hNBEd"};